import React, { useState } from "react";
import { Box, Text, Button, VStack } from "@chakra-ui/react";

const TestConnection = () => {
  const [nodeStatus, setNodeStatus] = useState(null);
  const [error, setError] = useState(null);

  const testNodeConnection = async () => {
    try {
      // First try the /api/test-connection route
      const apiUrl = `/api/test-connection`;
      console.log("Testing connection to:", apiUrl);
      
      try {
        console.log("Request headers:", {
          Accept: "application/json",
          "Content-Type": "application/json",
        });
        
        const response = await fetch(apiUrl, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        console.log("Full response:", response);
        console.log("Response status:", response.status);
        console.log("Response headers:", [...response.headers.entries()]);
        console.log("Response URL:", response.url);

        if (response.ok) {
          const data = await response.json();
          console.log("Response data:", data);
          setNodeStatus(data);
          setError(null);
          return;
        }
        
        // If first route fails, log but don't throw yet
        const errorText = await response.text();
        console.error("First route error:", errorText);
        console.error("First route error status:", response.status);
      } catch (firstErr) {
        console.error("First route connection error:", firstErr);
        console.error("Error details:", firstErr.message);
      }
      
      // Try alternative route if first one fails
      console.log("Trying alternative route...");
      const altResponse = await fetch(`/test-connection`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      
      if (!altResponse.ok) {
        const altErrorText = await altResponse.text();
        throw new Error(`HTTP error! status: ${altResponse.status}, Details: ${altErrorText}`);
      }
      
      const data = await altResponse.json();
      console.log("Alternative route response data:", data);
      setNodeStatus(data);
      setError(null);
    } catch (err) {
      console.error("Connection error:", err);
      setError(`${err.message} - Please check server logs for more details`);
      setNodeStatus(null);
    }
  };

  const testAllEndpoints = async () => {
    setError(null);
    const endpoints = [
      { url: '/api/ping', name: 'API Ping' },
      { url: '/api/user/demo-status', name: 'Demo Status' },
      { url: '/api/user/details', name: 'User Details' },
      { url: '/api/get-conversations', name: 'Conversations' },
      { url: '/api/plans', name: 'Plans' }
    ];
    
    const results = [];
    
    for (const endpoint of endpoints) {
      try {
        const response = await fetch(endpoint.url, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
          },
        });
        
        const contentType = response.headers.get('content-type');
        console.log(`${endpoint.name} Content-Type:`, contentType);
        
        let data;
        try {
          if (contentType && contentType.includes('application/json')) {
            data = await response.json();
          } else {
            data = await response.text();
          }
        } catch (parseErr) {
          data = `Parse error: ${parseErr.message}`;
        }
        
        results.push({
          endpoint: endpoint.name,
          url: endpoint.url,
          status: response.status,
          ok: response.ok,
          contentType,
          data
        });
      } catch (err) {
        results.push({
          endpoint: endpoint.name,
          url: endpoint.url,
          error: err.message
        });
      }
    }
    
    console.table(results);
    return results;
  };

  return (
    <Box p={4}>
      <VStack spacing={4} align="stretch">
        <Button onClick={testNodeConnection} colorScheme="blue" mr={2}>
          Test Node Connection
        </Button>
        <Button onClick={testAllEndpoints} colorScheme="green">
          Test All Endpoints
        </Button>

        {error && <Text color="red.500">Error: {error}</Text>}

        {nodeStatus && (
          <Box>
            <Text color="green.500" fontWeight="bold">
              Node.js Server Status: {nodeStatus.status}
            </Text>
            <Text>Message: {nodeStatus.message}</Text>
            <Text>Server Time: {nodeStatus.serverTime}</Text>
            <Text>Server URL: {nodeStatus.serverUrl}</Text>
          </Box>
        )}
        
        <Text fontWeight="bold" mt={4}>Check the console for detailed endpoint test results</Text>
      </VStack>
    </Box>
  );
};

export default TestConnection;
